<template>
  <v-dialog :value="value" @input="v => v || close()" max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">データダウンロード</span>
      </v-card-title>
      <v-card-text class="py-0">
        <span><h5>「{{ folderName }}」のデータをダウンロードします。</h5>
          <h5>種類を選択してください。</h5>
        </span>
        <v-form ref="dataDownloadForm" lazy-validation>
          <v-radio-group v-model="type" :rules="[v => !!v || '種類を選択してください。']" required>
            <v-radio
              v-for="item in fileTypes"
              :key="item.value"
              :label="`${item.text}`"
              :value="item.value"
              :disabled="fileTypeDisabled(item.value)"
            >
              <template v-slot:label>
                {{item.text}}
                <v-spacer></v-spacer>
                <v-checkbox
                    v-if="type === item.value && (item.value === 'tif_thermal' || item.value === 'tif_color')"
                    v-model="option"
                    label="アノテーション付き"
                ></v-checkbox>
              </template>
            </v-radio>
          </v-radio-group>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="close()">キャンセル</v-btn>
        <v-btn depressed @click="download" color="primary">ダウンロード</v-btn>
      </v-card-actions>
      <v-overlay
          absolute
          :value="overlay"
      >
        <v-progress-circular
            indeterminate
            color="primary"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>
<script>
import { store } from "@/store";

export default {
  name: "DataDownloadDialog",
  
  props: ["value"],
  data() {
    return {
      folderName: '',
      type: '',
      files: [],
      fileTypes :[
        {text: "アノテーション (CSV)", value: 'annotation'},
        {text: "サーモ素材画像", value: 'thermal'},
        {text: "サーモオルソ画像", value: "tif_thermal"},
        {text: "可視素材画像", value: 'color'},
        {text: "可視オルソ画像", value: 'tif_color'},
        {text: "点群", value: 'las'},
        {text: "3Dモデル", value: 'obj'},
      ],
      option: false,
      overlay: false
    };
  },
  methods: {
    getData() {
      this.files = [];
      this.folderName = '';
      this.option = false;
      const folderId = store.state.mapview.folderId;
      this.axios
        .get("/api/folder/" + folderId + "/files")
        .then((response) => {
          this.files = response.data.data;
          this.folderName = response.data.name;
        });
    },
    fileTypeDisabled(fileType) {
      if (fileType === 'annotation') return false;
      return !this.files[fileType];
    },
    download() {
      if(this.$refs.dataDownloadForm.validate()){
        if (this.type === 'annotation') {
          this.downloadAnnotation();
          return;
        }
        if (this.type === 'color' || this.type === 'thermal') {
          window.location.href = `/api/folder/images/download/${store.state.mapview.folderId}/${this.type}?token=${store.state.token}`;
          return;
        }
        if (this.option){
          this.overlay = true;
          let type = '';
          if (this.type === 'tif_thermal'){
            type = 'thermal';
          }
          else if (this.type === 'tif_color'){
            type = 'color';
          }
          this.axios.post('/api/folder/images/download-with-annotation/' + store.state.mapview.folderId + '/' + type, { filter: store.getFilter(this.folderId) }).then((response) => {
            window.location.href = response.data;
          }).finally(() => {
            this.overlay = false;
          });
          // window.location.href = this.files[`${this.type}_annotation`];
        }
        else{
          window.location.href = this.files[this.type];
        }
      }
    },
    downloadAnnotation() {
      this.axios.get('/api/annotation/' + store.state.mapview.folderId)
        .then(response => {
          // Create CSV content
          const data = response.data;
          const list = data.annotation.panel_abnormality.list;
          let csvContent = "data:text/csv;charset=utf-8,";
          csvContent += "種類,原因,緯度,経度\r\n";
          list.forEach(item => {
              csvContent += `${this.getAbnormalityTypeString(item.type)},${this.getAbnormalityReasonString(item.reason)},${item.coordinates[0]},${item.coordinates[1]}\r\n`;
          });
          // Download File
          const fileName = `${data.plant.name}_${data.folder.property.shooting_date}.csv`
          const encodedUri = encodeURI(csvContent);
          const link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", fileName);
          document.body.appendChild(link); // Required for FF
          link.click();
        })
    },
    getAbnormalityTypeString(value) {
      const types = [
        { text: "ホットスポット", value: "cell" },
        { text: "マルチホットスポット", value: "multicell" },
        { text: "クラスタバイパス", value: "cluster" },
        { text: "モジュール異常", value: "module" },
        { text: "ストリング異常", value: "string" },
        { text: "ジャンクションボックス過熱", value: "junction" },
        { text: "ＰＩＤ現象の疑い", value: "pid" },
        { text: "影", value: "shadow" },
      ];
      const type =  types.find(x => x.value == value);
      return type ? type.text : '';
    },
    getAbnormalityReasonString(value) {
      const reasons = [
        { text: "割れ", value: "crack" },
        { text: "堆積物", value: "sediment" },
        { text: "植生", value: "vegetation" },
      ];
      const reason = reasons.find(x => x.value == value);
      return reason ? reason.text : '';
    },
    close () {
      store.updateOpenDialog(false);
      this.$emit("input");
      this.$refs.dataDownloadForm.reset()
    }
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        store.updateOpenDialog(true);
        this.getData();
      }
    }
  },
};
</script>
